import { useEffect, useState } from "react";
import { RefreshCw, AlertTriangle } from "lucide-react";
import { cn } from "../lib/utils";

export const RINGBA_WARNING = "Ringba sync unavailable, showing analytics data";

export const relativeTime = (date) => {
  if (!date) return "Never";
  const secs = Math.max(0, Math.floor((Date.now() - new Date(date).getTime()) / 1000));
  if (secs < 10) return "just now";
  if (secs < 60) return `${secs} seconds ago`;
  const mins = Math.floor(secs / 60);
  if (mins < 60) return `${mins} minute${mins !== 1 ? "s" : ""} ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs} hour${hrs !== 1 ? "s" : ""} ago`;
  const days = Math.floor(hrs / 24);
  return `${days} day${days !== 1 ? "s" : ""} ago`;
};

export const RingbaWarning = ({ show, testId = "ringba-warning" }) => {
  if (!show) return null;
  return (
    <span
      className="inline-flex items-center gap-1 text-[11px] text-amber-400 whitespace-nowrap"
      title={RINGBA_WARNING}
      data-testid={testId}
    >
      <AlertTriangle className="h-3.5 w-3.5" />
      <span className="hidden lg:inline">{RINGBA_WARNING}</span>
    </span>
  );
};

export const SyncDataButton = ({ onSync, syncing, lastSynced, ringbaUnavailable = false, testId = "sync-data-btn", className }) => {
  const [, tick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => tick((t) => t + 1), 15000);
    return () => clearInterval(id);
  }, []);

  return (
    <div className={cn("flex items-center gap-2", className)}>
      <RingbaWarning show={ringbaUnavailable} testId={`${testId}-ringba-warning`} />
      <span className="text-[11px] text-slate-500 whitespace-nowrap" data-testid={`${testId}-last-synced`}>
        Last synced: <span className="text-slate-300 font-medium">{relativeTime(lastSynced)}</span>
      </span>
      <button
        onClick={onSync}
        disabled={syncing}
        className="flex items-center gap-1.5 bg-blue-600/15 border border-blue-500/30 rounded-lg px-3 py-1.5 text-sm text-blue-300 hover:bg-blue-600/25 transition disabled:opacity-60"
        data-testid={testId}
      >
        <RefreshCw className={cn("h-3.5 w-3.5", syncing && "animate-spin")} />
        {syncing ? "Syncing..." : "Sync Data"}
      </button>
    </div>
  );
};
